import React, { Component } from 'react';

export default class Resizer extends Component {
  getStyle() {
    const { isToggleMode, isOpen, direction } = this.props;
    const isColumn = direction === 'column';

    // La barra: resize cuando está abierto; pointer cuando está cerrado (solo toggle).
    // El handle siempre fuerza pointer por CSS.
    let cursor;
    if (isToggleMode) {
      cursor = isOpen
        ? (isColumn ? 'row-resize' : 'col-resize')
        : 'pointer';
    } else {
      cursor = isColumn ? 'row-resize' : 'col-resize';
    }

    if (isColumn) {
      return {
        width: '100%',
        height: this.props.size,
        background: this.props.color,
        cursor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      };
    }

    return {
      width: this.props.size,
      height: '100%',
      background: this.props.color,
      cursor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    };
  }

  handleToggleClick = (e) => {
    e.stopPropagation();
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  handleToggleMouseDown = (e) => {
    // Evita que el mousedown del handle inicie un resize de la barra
    e.stopPropagation();
  };

  handleToggleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  };

  render() {
    const { isToggleMode, isOpen, onClick, onMouseDown, direction } = this.props;
    const isColumn = direction === 'column';

    return (
      <div
        onMouseDown={onMouseDown}
        onClick={!isToggleMode || !isOpen ? onClick : undefined}
        className={`resizer ${isToggleMode ? 'resizer-toggle' : ''} ${isOpen ? 'is-open' : 'is-closed'} ${isColumn ? 'resizer-column' : 'resizer-row'}`}
        style={this.getStyle()}
      >
        {isToggleMode ? (
          <button
            type="button"
            className="resizer-handle"
            onClick={this.handleToggleClick}
            onMouseDown={this.handleToggleMouseDown}
            onKeyDown={this.handleToggleKeyDown}
            aria-label={isOpen ? 'Cerrar panel' : 'Abrir panel'}
          >
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
          </button>
        ) : (
          <div className="resizer-handle" aria-hidden="true">
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
            <span className="resizer-handle-dot" />
          </div>
        )}
      </div>
    )
  }
}
